import React from 'react';

const InputDropdown = ({
  arr,
  setSelectedLesson,
  closeDropdown,
  setSelectedLessonId,
}) => {
  return (
    <div className='input-dropdown'>
      {arr.length > 0 ? (
        arr?.map((el) => (
          <div
            className='input-dropdown__item'
            key={el?.id}
            onClick={() => {
              setSelectedLesson(el);
              setSelectedLessonId(el?.id);
              closeDropdown();
            }}
          >
            <p>{el?.title}</p>
          </div>
        ))
      ) : (
        <div
          style={{
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <p>You have not created any lesson</p>
        </div>
      )}
    </div>
  );
};

export default InputDropdown;
